// extracted by mini-css-extract-plugin
export default {"section":"bloggen_section__ZIxho","plus":"bloggen_plus__ZBrjc","actionBox":"bloggen_actionBox__IAZ9O","authorDropDown":"bloggen_authorDropDown__iWiEr"};